// AUX site-wide behaviour (loaded on every page).

// Any plain link to the search page (e.g. "Sök" in the footer) opens the same search modal as the header icon.
document.addEventListener('click', (event) => {
  const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
  if (!link || event.metaKey || event.ctrlKey || event.shiftKey) return;
  const url = new URL(link.href, location.href);
  if (url.origin !== location.origin || url.search || !/(^|\/)search\/?$/.test(url.pathname)) return;
  const modal = document.getElementById('search-modal');
  if (!modal || typeof modal.showDialog !== 'function') return;
  event.preventDefault();
  modal.showDialog();
});
